import { Callback, WizardState } from '../types';

const state: WizardState = {
  subscribers: new Set(),
};

export const wizardStore = {
  getState: () => state,

  subscribe: (callback: Callback) => {
    state.subscribers.add(callback);
    return () => {
      state.subscribers.delete(callback);
    };
  },

  notify: () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const callback of state.subscribers) callback();
  },

  setIsLoadingNextButton(value: boolean) {
    state.isLoadingNextButton = value;
    wizardStore.notify();
  },

  setDisableNextButton(value: boolean) {
    state.disableNextButton = value;
    wizardStore.notify();
  },

  setDisablePreviousButton(value: boolean) {
    state.disablePreviousButton = value;
    wizardStore.notify();
  },

  setDisableSkipButton(value: boolean) {
    state.disableSkipButton = value;
    wizardStore.notify();
  },

  setOnNext(fn?: (onSuccess?: () => void) => void) {
    state.onNext = fn;
    wizardStore.notify();
  },

  setOnPrevious(fn?: (onSuccess?: () => void) => void) {
    state.onPrevious = fn;
    wizardStore.notify();
  },

  setOnSkip(fn?: (onSuccess?: () => void) => void) {
    state.onSkip = fn;
    wizardStore.notify();
  },

  resetCallbacks() {
    state.onNext = undefined;
    state.onPrevious = undefined;
    state.onSkip = undefined;
    wizardStore.notify();
  },

  resetButtons() {
    state.isLoadingNextButton = false;
    state.disableNextButton = false;
    state.disablePreviousButton = false;
    state.disableSkipButton = false;
    wizardStore.notify();
  },
};
